<template>
  <v-dialog v-model="visible" width="400" @keyup.esc="ok()" @keyup.enter="ok()" @click:outside="ok()">
    <v-card>
      <div class="pa-5 text-h6 grey--text text--darken-1">
        <v-icon>mdi-information</v-icon>
        {{ title }}
      </div>

      <div class="px-5 pb-3">
        <p>{{ message }}</p>
      </div>

      <div class="pa-3 text-right">
        <v-btn color="primary" min-width="120px" @click="ok()">
          <v-icon left>mdi-check</v-icon>
          OK
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "InformationDialog",
  data() {
    return {
      visible: false,
      title: "",
      message: "",
      resolve: null,
      reject: null,
    };
  },
  methods: {
    show(message = "", title = "") {
      this.visible = true;
      this.title = title;
      this.message = message;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    ok() {
      this.resolve(true);
      this.visible = false;
    },
  },
};
</script>
